import Component from '../abstracts/Component';

export default class FidelityComponent extends Component {

  get SELECTORS() {
    return {
      fidelityStepOne: ".js-fidelity-step-one",
      createFidelity: ".js-new-fidelity",
      fidelityError: ".js-new-fidelity-created-error",
      fidelitySuccess: ".js-new-fidelity-created-success",
      back: ".js-back-button"
    };
  }

  constructor() {
    super();
  }

  //attivazione nuova Fidelity
  newFidelity() {
    let ctx = this;
    $(this.SELECTORS.createFidelity).on('click', () => {

      $(ctx.SELECTORS.fidelityError).addClass("d-none");
      $(ctx.SELECTORS.fidelitySuccess).addClass("d-none");
      $(ctx.SELECTORS.createFidelity).attr("disabled","disabled");

      $.ajax({
        url: '/my-account/fidelity',
        type: 'POST',
        data: {
          'new-fidelity-card': true
        },
        dataType: "html"
      }).done(function (resp) {
        var respJson = JSON.parse(resp);
        $(ctx.SELECTORS.fidelityStepOne).addClass("d-none");
        if (respJson.error == 'yes') {
          $(ctx.SELECTORS.fidelityError).removeClass("d-none");
        } else {
          $(ctx.SELECTORS.fidelitySuccess).removeClass("d-none");
        }
      }).fail(function (xhr) {
        console.log(xhr);
        $(ctx.SELECTORS.fidelityStepOne).addClass("d-none");
        $(ctx.SELECTORS.fidelityError).removeClass("d-none");
      });
    });

    $(this.SELECTORS.back).on('click', () => {
      $('.vex-close').trigger('click');
      window.location.reload();
    });
  }


  bindEvents() {
    var ctx = this;
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, ({event}) => {
      if($(ctx.SELECTORS.createFidelity).length > 0) {
         ctx.newFidelity();
      }
    });
  }

  render() {
    this.bindEvents();
  }
}
